"use strict";
/**
 * Database Operation Result Types
 *
 * USAGE:
 *
 * 1. Import AWS SDK output types directly from @aws-sdk/lib-dynamodb:
 *    import type { QueryCommandOutput, GetCommandOutput } from '@aws-sdk/lib-dynamodb';
 *
 * 2. Type the DynamoDB result:
 *    const result: QueryCommandOutput = await dynamo.send(new QueryCommand({...}));
 *
 * 3. Cast Items/Item to specific record type:
 *    const items = result.Items as RecordType[] | undefined || [];
 *    const item = result.Item as RecordType | undefined;
 *
 * COMPLETE EXAMPLE:
 *    const result: QueryCommandOutput = await withRetry(
 *      () => dynamo.send(new QueryCommand({...})),
 *      ErrorType.DYNAMODB_FAILURE,
 *      { operation: 'queryPatterns' }
 *    );
 *    const patterns = result.Items as PatternDisplayRecord[] | undefined || [];
 */
Object.defineProperty(exports, "__esModule", { value: true });
